export const presaleDateTimeAppenderValues = {
  displayDate: 'Display the date',
  displayDateAndTime: 'Display the date and time',
} as const;

export const buildPreFirstShowtimeMessage = (movieTitle: string, firstShowDate: Date): string => {
  const formattedDate = firstShowDate.toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'long',
    weekday: 'long',
    year: 'numeric',
  });
  return `The first showtimes scheduled for ${movieTitle} are on ${formattedDate}.`;
};

export const buildPresaleMessage = (
  movieTitle: string,
  options?: {
    presaleDateTimeAppender?: string;
    presaleLinkText?: string;
    presaleLinkUrl?: string;
    publicOnSaleDate?: Date;
  }
): string => {
  if (options?.presaleLinkUrl && options?.presaleLinkText) {
    return `Tickets for ${movieTitle} are currently only offered for sale through`;
  }

  if (options?.publicOnSaleDate) {
    const date = options.publicOnSaleDate;

    if (options.presaleDateTimeAppender === presaleDateTimeAppenderValues.displayDateAndTime) {
      const formattedDate = date.toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' });
      const formattedTime = date.toLocaleTimeString('en-US', { hour: 'numeric', hour12: true, minute: '2-digit' });
      return `Tickets for ${movieTitle} will go on sale ${formattedDate} at ${formattedTime}.`;
    }

    if (options.presaleDateTimeAppender === presaleDateTimeAppenderValues.displayDate) {
      const formattedDate = date.toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' });
      return `Tickets for ${movieTitle} will go on sale ${formattedDate}.`;
    }
  }

  return `Tickets for ${movieTitle} are not yet on sale.`;
};
